module.exports = __webpack_public_path__ + "static/media/DinningArea-b-f.8b34e98c.webp";